import classNames from 'classnames'
import React, { ReactNode } from 'react'

import { GridColumn } from '../../grid/grid-column.js'
import { Grid } from '../../grid/grid.js'

export interface CartItemProps {
    className?: string
    large?: boolean
    title?: string
    subTitle?: string
    price?: string
    specialPrice?: string
    subPrice?: string
    children?: ReactNode
    fullWidth?: boolean
}

export const CartItem = (props: CartItemProps): JSX.Element => {
    const className: string = classNames('cart-item', props.fullWidth && 'cart-item--full-width', props.className)

    const sizeClass: string = props.large ? 'text-huge' : 'text-small'
    const subSizeClass = 'text-small'

    return (
        <div className={className}>
            <Grid noWrap={['xs']}>
                <GridColumn width={['max-xs']}>
                    {props.title && (
                        <p className={sizeClass}>
                            <strong>{props.title}</strong>
                        </p>
                    )}
                    {props.subTitle && <p className={subSizeClass}>{props.subTitle}</p>}
                </GridColumn>

                <GridColumn width={['min-xs']} className="h-text-right">
                    {props.price && <p className={'text-price ' + sizeClass}>{props.price}</p>}
                    {props.specialPrice && <p className={'text-price is-special ' + sizeClass}>{props.specialPrice}</p>}
                    {props.subPrice && (
                        <p className={subSizeClass}>
                            <strong>{props.subPrice}</strong>
                        </p>
                    )}
                </GridColumn>
            </Grid>
            {props.children}
        </div>
    )
}
